























module.exports =
  name: 'day'
  components:
    transaction: require('./transaction.vue').default
    balance:     require('components/inside/elements/balance.vue').default
    week_number: require('./day_week_number.vue').default
  props: ['day', 'transactions', 'week_index']
  data: -> { display_tooltip: false }
  computed:
    day_real_sum: ->
      incomes:   @$store.getters.transactions_sum(@transactions.filter (tr) -> tr.subtype == 'i')
      expenses:  @$store.getters.transactions_sum(@transactions.filter (tr) -> tr.subtype == 'e')
    day_plan_sum: ->
      not_confirmed = @transactions.filter (tr) -> tr.isUnconfirmed()
      return
        incomes:  @$store.getters.transactions_plan_sum(not_confirmed.filter (tr) -> tr.subtype == 'i')
        expenses: @$store.getters.transactions_plan_sum(not_confirmed.filter (tr) -> tr.subtype == 'e')
    has_real_sum: -> @day_real_sum.incomes != 0 || @day_real_sum.expenses != 0
    has_plan_sum: -> @day_plan_sum.incomes != 0 || @day_plan_sum.expenses != 0
    has_day_sum: -> @has_real_sum || @has_plan_sum
  methods:
    newTransaction: (day, event, attrs = {}) ->
      if event.altKey
        attrs.subtype = 't'
        attrs.transfer_type = 'a'
      else if event.shiftKey
        attrs.subtype = 't'
        attrs.transfer_type = 'v'
      else if event.doubleClick
        attrs.subtype = 'i'
      else
        attrs.subtype = 'e' unless attrs.subtype # don't overwrite passed subtype
      attrs.date = day.dateIso

      @$store.dispatch 'hideTransactionsPopovers'
      @$nextTick =>
        @$store.dispatch('initTransaction', attrs).then (new_transaction) =>
          @$store.dispatch 'selectTransaction', new_transaction
    select: (transaction) ->
      @$store.dispatch 'hideTransactionsPopovers'
      @$nextTick => @$store.dispatch 'selectTransaction', transaction
    showTooltip: ->
      return if HM.is_mobile
      @display_tooltip = true
      return unless @has_day_sum
      @$nextTick =>
        @tooltip = $(@$el).find('.el-tooltip__popper').show()
        if @tooltip.length
          @popper = new Popper($(@$el).find('.day_number_text'), @tooltip, { placement: 'bottom' })
    hideTooltip: ->
      @display_tooltip = false
      @tooltip.hide() if @tooltip
      @popper.destroy() if @popper
  beforeDestroy: ->
    requestIdleCallback =>
      @sortable.destroy()
      @sortable = null
  mounted: ->
    requestIdleCallback =>
      @sortable = new Sortable @$el,
        group: 'transactions'
        sort: false
        delay: (if @HM.is_touch then 500 else 0)
        draggable: '.transaction'
        onStart: =>
          @$store.dispatch 'selectTransaction', {}
          @$store.state.ui.transactions.calendar.highlighted_transaction = null
        onMove: (evt, originalEvent) =>
          @$store.state.ui.transactions.calendar.highlighted_transaction = null
          if originalEvent.altKey || originalEvent.ctrlKey
            $('.transaction.sortable-chosen, .transaction.sortable-drag, .transaction.sortable-ghost').addClass('is_clone')
            evt.dragged._is_clone = true
          else
            $('.transaction').removeClass('is_clone')
            evt.dragged._is_clone = false
          return true # we need it, otherwise it won't move
        onEnd: (evt) =>
          evt.item._is_clone = false
          $('.transaction').removeClass('is_clone')
        onAdd: (evt) =>
          id = Number(evt.item.getAttribute('transaction_id'))
          transaction = _.find @$store.state.user.transactions, { id: id }

          if evt.item._is_clone == true
            transaction      = _.clone transaction
            transaction.common_id = null # break the chain of planned transactions
            transaction.id   = undefined
            transaction.date = evt.to.getAttribute('date')
            $(evt.item).appendTo(evt.from) # return original transaction back to it's old day
            @newTransaction @day, {}, transaction
          else
            transaction.date = evt.to.getAttribute('date')
            dispatch = (mode, change_future_trs) =>
              opts = { transaction: transaction, mode: mode, user: @$store.state.user, change_future_trs: change_future_trs }
              @$store.dispatch('saveTransaction', opts).then =>
                @$message
                  type: 'success'
                  message: @$t('Done')
                  duration: 1000

            if transaction.planned_repeat_days > 0 and !_.isNumber(transaction.real_amount)
              promise = @$confirm @$t('Or move only this one?'), @$t('Do you want to move future transactions too?'),
                confirmButtonText: @$t('Move this one and future ones'),
                cancelButtonText: @$t("Move only one"),
                type: 'warning'
              promise.then  => dispatch('plan', true)
              promise.catch => dispatch('plan', false)
            else
              dispatch('enter', false) if _.isNumber(transaction.real_amount)
              dispatch('plan', false) unless _.isNumber(transaction.real_amount)


